module.exports = __webpack_public_path__ + "prod/1.42.2/img/icon-fail.453c3690.svg";